import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import Loading from "../../Shared/Loading";
import SuperAdminAllRessellerTable from "./SuperAdminAllRessellerTable";
import SuperAdminRessellerModal from "./SuperAdminModal/SuperAdminRessellerModal";
import SuperAdminAddUserModal from "./SuperAdminModal/SuperAdminAddUserModal";

const SuperAdminDashboardIndex = () => {
  const [modalIsOpenAddResseller, setModalIsOpenAddResseller] = useState(false);
  const [isOpenAddUser, setIsOpenAddUser] = useState(false);
  const [reseller, setReseller] = useState([]);
  const [user, setUser] = useState({});
  const [doctor, setDoctor] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDoctors = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://servercareseebd.careseebd.com/api/v1/user", {
          headers: {
            authorization: `Bearer ${localStorage.getItem(
              "careSeeAccessToken"
            )}`,
          },
        });
        const data = await response.json();

        const resellerData = data.data.filter((user) => user?.role === "admin");
        setReseller(resellerData);
        const userData = data.data.filter((user) => user?.role === "user");

        setUser(userData);
        const doctorData = data.data.filter((user) => user?.role === "doctor");

        setDoctor(doctorData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching doctors:", error);
      }
    };

    fetchDoctors();
  }, []);

  const openModalAddResseller = () => {
    setModalIsOpenAddResseller(true);
  };

  const closeModalAddResseller = () => {
    setModalIsOpenAddResseller(false);
  };
  const openModalAddUser = () => {
    setIsOpenAddUser(true);
  };

  const closeModalAddUser = () => {
    setIsOpenAddUser(false);
  };


  if (loading) {
    return <Loading />;
  }
  return (
    <div className="">
      <div className=" lg:grid lg:grid-cols-3 gap-5  md:grid md:grid-cols-3 font-bold mb-4">
        <div className=" flex justify-center items-center  bg-[#E3156F] shadow text-white h-40 mb-2  max-w-xs  rounded-md gap-2 text-xl">
          <Icon icon="subway:admin-1"></Icon>
          <p>Total Reseller: </p>
          <p>{reseller?.length}</p>
        </div>
        <div className=" flex justify-center items-center bg-[#DC3545] text-white shadow h-40 mb-2 max-w-xs rounded-md gap-2 text-xl">
          <Icon icon="subway:admin-1"></Icon>
          <p>Total Doctor:</p>
          <p>{doctor?.length}</p>
        </div>
        <div className=" justify-center flex items-center bg-[#CF4514] text-white shadow h-40 mb-2 max-w-xs rounded-md gap-2 text-xl">
          <Icon icon="subway:admin-1"></Icon>
          <p>Total Patient: </p>
          <p>{user?.length}</p>
        </div>
      </div>
      <div className="bg-gray-200 h-[1px] w-full "></div>

      <div className=" flex justify-start items-center gap-5 mt-5">
        <button
          onClick={openModalAddResseller}
          className="transform hover:scale-110 duration-300 flex justify-center p-3 items-center gap-2 bg-secondary shadow-md rounded-md w-36 text-white max-auto  cursor-pointer"
        >
          <Icon icon="gala:add"></Icon>
          <span>Add reseller</span>
        </button>
        <button
          onClick={openModalAddUser}
          className="transform hover:scale-110 duration-300 flex justify-center p-3 items-center gap-2 bg-secondary shadow-md rounded-md w-36 text-white max-auto  cursor-pointer"
        >
          <Icon icon="gala:add"></Icon>
          <span>Add User</span>
        </button>

        <SuperAdminRessellerModal
          isOpen={modalIsOpenAddResseller}
          closeModal={closeModalAddResseller}
        ></SuperAdminRessellerModal>

        <SuperAdminAddUserModal
          isOpen={isOpenAddUser}
          closeModal={closeModalAddUser}
        ></SuperAdminAddUserModal>
      </div>
      <div className="bg-gray-200 h-[1px] w-full mt-5 "></div>

      <SuperAdminAllRessellerTable></SuperAdminAllRessellerTable>
    </div>
  );
};

export default SuperAdminDashboardIndex;
